export default {
  "dbi-mobile-device-title": "移动设备",
  "dbi-mobile-device-overview-title": "移动设备全球概览",
  "dbi-mobile-device-stats-title": "移动设备数据",
  "dbi-mobile-device-year": "年份",
  "dbi-mobile-device-month": "月份",
  "dbi-mobile-device-number": "全球设备数量",
  "dbi-mobile-device-number-atthened-1": "截至 ",
  "dbi-mobile-device-number-atthened-2": " 年底的全球设备数量",
  "dbi-mobile-device-top5Models": "{time} 活跃设备数排名前 5 位的机型",
  "dbi-mobile-device-top5Models-1": " ",
  "dbi-mobile-device-top5Models-2": " 年活跃用户数排名前 5 位的机型",
  "dbi-mobile-device-RAM-distribution": "内存分配",
  "dbi-mobile-device-top-system-chips": "热门系统芯片",
  "dbi-mobile-device-tiers-map": "基于内存和芯片的手机机型等级分布详情",
  "dbi-mobile-device-tier": "档位",
  "dbi-mobile-device-active-device": '活跃设备',
  "dbi-mobile-device-country": '国家',
  "dbi-mobile-device-download-success": "下载成功",
  "dbi-mobile-device-download-full-data": "下载最新数据",
  "dbi-mobile-device-Top-500-mobile-models": "月度机型数据下载",
  "dbi-mobile-device-download-loading": "下载中...",
  "dbi-mobile-device-info-intro": "IEG Global 根据内存和芯片为移动设备设定了等级。",
  "dbi-mobile-device-android": "安卓",
  "dbi-mobile-device-PnO-map": "手机机型等级分布地图",
  "dbi-mobile-device-modal_line_header": "安卓机型的基线",
  "dbi-mobile-device-modal_line_header_ios": "iOS机型的基线",
  "dbi-mobile-device-stall": "档位",
  "dbi-mobile-device-baseline_grading": "芯片分档的基线",
  "dbi-mobile-device-user_share": "用户占比(全球)",
  "dbi-mobile-device-remarks": "备注说明",
  "dbi-mobile-device-tier-ram-chips": "{num}档机内存和芯片",
  "dbi-mobile-device-ofdevice": "设备占比",
  "dbi-mobile-device-number-device": "设备数量",
  "dbi-mobile-device-download_info": "可在Mobile Device-Overview页面下载月度完整设备数据",
  "dbi-mobile-device-download_info_btn": "下载所有统计国家的最新数据"
}